(function () {
  // ---------- Config ----------
  const PER_BLOCK = 6;
  const ROOT_SEL  = '[data-product-section], section[id*="Product"], .product, [id^="ProductInfo-"]';
  const RADIO_SEL = 'radio-swatch input[type="radio"][name="options[Color]"]';
  const MEDIA_SEL = '.product__media';

  // ---------- Utils ----------
  const isVisible = el => !!(el && el.offsetParent !== null) && !el.disabled;
  const getRoot   = el => (el && el.closest && el.closest(ROOT_SEL)) || document;

  const debounce = (fn, wait = 50) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
  };

  // ---------- Selection helpers ----------
  function getCheckedRadio(root) {
    const radios = Array.from(root.querySelectorAll(RADIO_SEL)).filter(isVisible);
    return radios.find(r => r.checked) || radios[0] || null;
  }

  function getVariantIndex(root) {
    const r = getCheckedRadio(root);
    if (!r) return 0;
    const n = parseInt(r.getAttribute('data-swatch-index'), 10);
    if (!Number.isNaN(n)) return Math.max(0, n);     // your HTML is 0-based
    const radios = Array.from(root.querySelectorAll(RADIO_SEL)).filter(isVisible);
    return Math.max(0, radios.indexOf(r));           // fallback by DOM order
  }

  function getSwatchImageId(root) {
    const r = getCheckedRadio(root);
    if (!r) return null;
    const label = root.querySelector(`label[for="${r.id}"]`);
    return label ? (label.getAttribute('data-swatch-image-id') || null) : null;
  }

  // ---------- Media logic ----------
  function getMediaEls(root) {
    return Array.from(root.querySelectorAll(MEDIA_SEL));
  }

  function findAnchorStart(root) {
    const media = getMediaEls(root);
    if (!media.length) return 0;

    // Prefer anchoring to the swatch’s image id, if present
    const anchorId = getSwatchImageId(root);
    if (anchorId) {
      const pos = media.findIndex(el => el.getAttribute('data-media-id') === anchorId);
      if (pos >= 0) {
        // Clamp start so we can still show up to PER_BLOCK items
        const maxStart = Math.max(0, media.length - PER_BLOCK);
        return Math.max(0, Math.min(pos, maxStart));
      }
    }

    // Fallback: block by variant index
    const idx = getVariantIndex(root);
    const start = idx * PER_BLOCK;
    const maxStart = Math.max(0, media.length - PER_BLOCK);
    return Math.max(0, Math.min(start, maxStart));
  }

  function applyBlock(root) {
    const media = getMediaEls(root);
    if (!media.length) return;

    const start = findAnchorStart(root);
    const end   = Math.min(start + PER_BLOCK - 1, media.length - 1);

    media.forEach((el, i) => {
      const show = i >= start && i <= end;
      el.classList.toggle('hide', !show);
    });
  }

  // ---------- Orchestration ----------
  function updateRoot(root) {
    // Defer a tick so themes can finish applying checked states
    setTimeout(() => applyBlock(root), 0);
  }

  function initAll() {
    const roots = new Set(
      Array.from(document.querySelectorAll(RADIO_SEL)).map(getRoot)
    );
    roots.forEach(updateRoot);
  }

  // ---------- Boot ----------
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('pageshow', initAll); // bfcache restore

  // User selection
  document.addEventListener('change', (e) => {
    if (e.target.matches(RADIO_SEL)) updateRoot(getRoot(e.target));
  }, true);

  // Theme programmatic variant changes
  const reapply = (e) => updateRoot(getRoot(e.target || document));
  document.addEventListener('product:variant-change', reapply);
  document.addEventListener('variant:changed',        reapply);
  document.addEventListener('theme:swatch:change',    reapply);

  // Theme Editor actions (ensure it re-applies when sections are added/selected)
  document.addEventListener('shopify:section:load',   (e) => updateRoot(getRoot(e.target)));
  document.addEventListener('shopify:section:select', (e) => updateRoot(getRoot(e.target)));

  // Lazy/injected media → observe and re-apply (debounced)
  document.querySelectorAll('.product__grid, .product__media-list, .product__media-wrapper')
    .forEach(container => {
      const root = getRoot(container);
      const safeUpdate = debounce(() => updateRoot(root), 50);
      new MutationObserver(safeUpdate).observe(container, { childList: true, subtree: true });
    });
})();


// (function () {
//   const PER_BLOCK = 6;
//   const ROOT_SEL  = '[data-product-section], section[id*="Product"], .product, [id^="ProductInfo-"]';
//   const RADIO_SEL = 'radio-swatch input[type="radio"][name="options[Color]"]';
//   const MEDIA_SEL = '.product__media';

//   const isVisible = el => !!(el && el.offsetParent !== null) && !el.disabled;
//   const getRoot   = el => (el && el.closest && el.closest(ROOT_SEL)) || document;

//   function getCheckedRadio(root) {
//     // visible radios only (desktop/mobile duplicates ignore)
//     const radios = Array.from(root.querySelectorAll(RADIO_SEL)).filter(isVisible);
//     return radios.find(r => r.checked) || radios[0] || null;
//   }

//   function getSwatchImageId(root) {
//     const r = getCheckedRadio(root);
//     if (!r) return null;
//     // label via "for" attribute
//     const label = root.querySelector(`label[for="${r.id}"]`);
//     if (!label) return null;
//     return label.getAttribute('data-swatch-image-id') || null;
//   }

//   function getVariantIndex(root) {
//     const r = getCheckedRadio(root);
//     if (!r) return 0;
//     // prefer input's 0-based data-swatch-index (your HTML has it)
//     const n = parseInt(r.getAttribute('data-swatch-index'), 10);
//     if (!Number.isNaN(n)) return Math.max(0, n);
//     // fallback: DOM order
//     const radios = Array.from(root.querySelectorAll(RADIO_SEL)).filter(isVisible);
//     return Math.max(0, radios.indexOf(r));
//   }

//   function getMediaEls(root) {
//     return Array.from(root.querySelectorAll(MEDIA_SEL));
//   }

//   function findAnchorStart(root) {
//     const media = getMediaEls(root);
//     if (!media.length) return 0;

//     const anchorId = getSwatchImageId(root);
//     if (anchorId) {
//       const pos = media.findIndex(el => el.getAttribute('data-media-id') === anchorId);
//       if (pos >= 0) {
//         // clamp so we always have up to 6 images
//         return Math.max(0, Math.min(pos, media.length - PER_BLOCK));
//       }
//     }
//     // fallback: block by variant index
//     const vidx = getVariantIndex(root);
//     const start = vidx * PER_BLOCK;
//     return Math.max(0, Math.min(start, media.length - PER_BLOCK));
//   }

//   function applyBlock(root) {
//     const media = getMediaEls(root);
//     if (!media.length) return;

//     const start = findAnchorStart(root);
//     const end   = Math.min(start + PER_BLOCK - 1, media.length - 1);

//     const shown = [];
//     media.forEach((el, i) => {
//       const show = i >= start && i <= end;
//       el.classList.toggle('hide', !show);
//       if (show) shown.push(i);
//     });

//     // Debug
//     const r = getCheckedRadio(root);
//     console.groupCollapsed('🧭 Swatch→Images mapping');
//     console.log('checked value:', r?.value, 'id:', r?.id, 'swatch-index:', r?.getAttribute?.('data-swatch-index'));
//     console.log('label image id:', getSwatchImageId(root));
//     console.log(`show images [${start}..${end}]`, shown);
//     console.groupEnd();
//   }

//   function updateRoot(root) {
//     // small defer so theme updates checked state first
//     setTimeout(() => applyBlock(root), 0);
//   }

//   function initAll() {
//     const roots = new Set(Array.from(document.querySelectorAll(RADIO_SEL)).map(getRoot));
//     roots.forEach(updateRoot);
//   }

//   document.addEventListener('DOMContentLoaded', initAll);
//   window.addEventListener('pageshow', initAll);

//   document.addEventListener('change', (e) => {
//     if (e.target.matches(RADIO_SEL)) updateRoot(getRoot(e.target));
//   }, true);

//   const reapply = (e) => updateRoot(getRoot(e.target || document));
//   document.addEventListener('product:variant-change', reapply);
//   document.addEventListener('variant:changed',        reapply);
//   document.addEventListener('theme:swatch:change',    reapply);

//   // If media are injected later, keep in sync
//   document.querySelectorAll('.product__grid, .product__media-list, .product__media-wrapper')
//     .forEach(container => {
//       const root = getRoot(container);
//       new MutationObserver(() => updateRoot(root))
//         .observe(container, { childList: true, subtree: true });
//     });
// })();
